module.exports = __webpack_public_path__ + "static/img/wechat-qr.5479334.png";


//////////////////
// WEBPACK FOOTER
// ./src/assets/img/wechat-qr.png
// module id = z1do
// module chunks = 21